import Link from "next/link";

import useCanDoShop from "../../hooks/useCanDoShop.hook";

export default function OutlineLink({
  id,
  href,
  text,
  cap,
  bgColor = "bg-her-dodgerblue",
}: {
  id: string;
  href: string;
  text: React.ReactNode;
  cap?: ShopCap;
  bgColor?: string;
}) {
  const canDo = useCanDoShop(cap);

  if (canDo) {
    return (
      <Link id={id} href={href} className={`${bgColor} text-white px-3 py-1 rounded-md cursor-pointer`}>
        {text}
      </Link>
    );
  }

  return (
    <div id={id} className="text-her-lightgray2 border-her-lightgray2 bg-white/5 border px-3 py-1 rounded-md">
      {text}
    </div>
  );
}
